export default {
notification: {
  read: "Lido",
  unread: "Não lido",
  hide: "Ocultar",
  showAll: "Mostrar tudo",
  loading: "Carregando...",
  noMore: "Não há mais dados",
  platform: "Plataforma",
  personal: "Pessoal"
}
};
